import { Component, Input, OnInit } from '@angular/core';
import { LocalLoadStatus } from '../shared/local-load.model';

@Component({
  selector: 'app-local-load-status',
  templateUrl: './local-load-status.component.html',
  styleUrls: ['./local-load-status.component.scss']
})
export class LocalLoadStatusComponent implements OnInit {

  @Input()
  status: LocalLoadStatus;

  LocalLoadStatus = LocalLoadStatus;

  constructor() {
  }

  ngOnInit() {
  }

}
